import { formatWithCustomer } from '@peanuds/shared';

const DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
};

const TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  hour: '2-digit',
  minute: '2-digit',
};

/**
 * Formats an ISO date string to a readable date/time string.
 * Falls back to the original string if parsing fails.
 */
export const formatDateTime = (
  value: string,
  dateTimeConfig?: { locale?: Intl.LocalesArgument; pattern?: string },
): string => {
  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  if (dateTimeConfig?.pattern) {
    return formatWithCustomer(date, {}, dateTimeConfig);
  }

  const datePart = formatWithCustomer(date, DATE_OPTIONS, dateTimeConfig);
  const timePart = formatWithCustomer(date, TIME_OPTIONS, dateTimeConfig);

  return `${datePart} ${timePart}`;
};
